/**
 * Variant-based Size Filter System
 * Works with pre-2.0 Shopify themes using tag-based URL structure
 * URLs format: collections/name/size1+size2+tag
 * Integrates with existing AJAX filter system
 */

(function() {
  'use strict';
  
  function initVariantFilter() {
    // Wait for jQuery
    if (typeof jQuery === 'undefined' && typeof window.$ === 'undefined') {
      setTimeout(initVariantFilter, 100);
      return;
    }
    
    var $ = window.jQuery || window.$;
    
    console.log('VariantFilter: Starting initialization...');
    
    var VariantFilter = {
      isInitialized: false,

      init: function() {
        if (this.isInitialized) {
          console.log('VariantFilter: Already initialized, skipping');
          return;
        }
        
        console.log('VariantFilter: Initializing...');
        console.log('VariantFilter: Found filter options:', $('.variant-size-option').length);
        console.log('VariantFilter: Found products:', $('.mode-view-item, .product-parent-item').length);
        console.log('VariantFilter: Filter container exists:', $('#filter-variant-size').length > 0);
        
        // The filter now uses the existing tag-based system
        // No need for custom event handlers - the existing AJAX filter handles everything
        // We just need to ensure products are filtered correctly on page load
        
        // Re-apply filter after AJAX updates
        this.bindToAJAXUpdates();
        
        this.isInitialized = true;
        console.log('VariantFilter: Initialized successfully');
      },

      bindToAJAXUpdates: function() {
        var self = this;
        
        // Listen for AJAX filter updates
        $(document).on('filterUpdated', function() {
          console.log('VariantFilter: filterUpdated event received');
          setTimeout(function() {
            self.isInitialized = false;
            self.init();
          }, 300);
        });
        
        // Also listen for when AJAX filter completes
        if (typeof AT_Filter !== 'undefined') {
          // Hook into the existing AJAX filter success callback
          var originalRequestPage = AT_Filter.requestPage;
          if (originalRequestPage) {
            // The existing system already handles everything
            // We just need to ensure our filter UI updates correctly
            console.log('VariantFilter: Integrated with AT_Filter');
          }
        }
      }
    };

    // Initialize when ready
    $(document).ready(function() {
      console.log('VariantFilter: DOM ready, initializing...');
      VariantFilter.init();
    });

    // Also try after a delay in case DOM ready already fired
    setTimeout(function() {
      if (!VariantFilter.isInitialized) {
        console.log('VariantFilter: Delayed initialization');
        VariantFilter.init();
      }
    }, 1000);
    
    // Force initialization after page load
    window.addEventListener('load', function() {
      setTimeout(function() {
        if (!VariantFilter.isInitialized && typeof jQuery !== 'undefined') {
          console.log('VariantFilter: Force initialization on load');
          VariantFilter.init();
        }
      }, 500);
    });

    // Expose globally
    window.VariantFilter = VariantFilter;
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantFilter);
  } else {
    initVariantFilter();
  }

})();
